<template>
  <div id="video">
    <!-- all_in -->
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <Modal :title="nowTitle" v-model="modalvideo" class-name="vertical-center-modal-video">
      <p slot="header" style="color:#f60;text-align:center;margin: 0;">
      </p>
      <div style="text-align:center">
        <iframe width="560" height="315" :src="nowVideo" frameborder="0" allowfullscreen></iframe>
      </div>
      <div slot="footer">
      </div>
    </Modal>
    <div class="con_all" v-if="!$route.meta.keepAliveSub">
      <div class="con_two">
        <div class="tea_r_l">
          <input name="" type="text" class="psear_input" :placeholder="showPage.videoSearch" v-model="searchName">
          <button type="submit" class="gue_btn" @click="search">{{showPage.search}}</button>
        </div>
        <div class="tea_r_r">
          <span class="ca2_btn">{{showPage.orderByReleaseDate}}</span>
          <!--<button type="submit" class="ca2_btn" @click="sort" v-if="!sortstatus">{{showPage.orderByReleaseDate}}</button>
          <button type="submit" class="ca2_btn" @click="sortCancel" v-else>{{showPage.cancel}}</button>-->
        </div>
        <div class="fix"></div>
        <div class="photo_box" v-for="(video,index) in videos" :key="index" @click="selectVideo(video)" v-if="inCurrentPage(index)">
          <div class="photo_box_pic">
            <img :src="video.coverPictureUrl">
            <!-- <video src="Hello Ghost.mp4" controls="" autoplay="" loop="" muted="" preload="auto"></video> -->
          </div>
        </div>
        <div class="fix"></div>
        <div class="pagination-row text-center ml20">
          <Page :current="currentPage" :total="videos.length" style="margin-top:20px" :page-size="pagesize" @on-change="changePage"></Page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, PostErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'video',
  data() {
    return {
      allVideos: [],
      videos: [],
      nowVideo: '',
      nowTitle: '',
      searchName: '',
      currentPage: 1,
      pagesize: 10,
      modalvideo: false,
      sortstatus: false,
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initVideos();
    },
    initVideos() {
      this.getVideosData();
    },
    getVideosData() {
      axios.get(API.video)
        .then(response => {
          this.allVideos = response.data;
          this.sort();
          this.videos = this.allVideos.slice();
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },

    selectVideo(video) {
      this.nowVideo = video.fileUrl;
      this.nowTitle = this.showTitle(video);
      this.modalvideo = true;
      this.addViewCount(video);
    },
    addViewCount(video) {

      let form = new FormData();

      form.append('id', video.id);

      // params   id account name isActive limit all
      axios.post(API.video + '/viewer', form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          // ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
        })
        .catch(error => {
          // PostErrorHandler.bind(this)(error, 'album');
        });
    },

    search() {
      if (this.searchName) {
        this.videos = this.allVideos.filter(row => {
          return Object.keys(row).some(key => {
            if (key !== 'titleCh' && key !== 'titleEn') return false;
            return String(row[key]).toLowerCase().indexOf(this.searchName) !== -1;
          });
        });
      } else
        this.videos = this.allVideos.slice();

      this.currentPage = 1;
    },
    sort() {
      this.sortstatus = true;
      this.allVideos.sort((a, b) => {
        let aDate = new Date(a.createdAt),
          bDate = new Date(b.createdAt);
        if (aDate.getTime() < bDate.getTime())
          return 1;
        return -1;
      });
    },
    sortCancel() {
      this.sortstatus = false;
      this.videos = this.allVideos.slice();
    },

    changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage(index) {
      let currentPage = this.currentPage,
        pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize
    },




    showTitle(video) {
      let show = { CH: video.titleCh, EN: video.titleEn }
      return show[sessionStorage.locale];
    }
  },
}

</script>
<style lang="scss">
#video {
  .photo_box {
    height: 200px;
    overflow: hidden;
  }
}


.vertical-center-modal-video {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal-body {
    text-align: center;
  }
  .ivu-modal {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: 500px;
    width: 592px!important;
  }
}

</style>



// WEBPACK FOOTER //
// Video.vue?0e392f0a